/** Полноэкранная заглушка загрузки на время начального определения сессии. */
export function FullScreenLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg text-txt-secondary">
      <span>Загрузка…</span>
    </div>
  )
}
